import { render, staticRenderFns } from "./LanguagePicker.vue?vue&type=template&id=f3f0690a&scoped=true&"
import script from "./LanguagePicker.vue?vue&type=script&lang=js&"
export * from "./LanguagePicker.vue?vue&type=script&lang=js&"
import style0 from "./LanguagePicker.vue?vue&type=style&index=0&id=f3f0690a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f0690a",
  null
  
)

export default component.exports